/**
 * Initialize widget-related JavaScript functionality.
 */
export function initWidgets() {
  // Widget recent entries styling
  $('.widget_recent_entries a').each(function() {
    var words = $(this).text().split(' ');
    $(this).html(words.map(word => `<span>${word}</span>`).join(' '));
  });

  // Widget block handling
  $('.widget_block').each(function() {
    var paragraphs = $(this).find('p');
    var emptyParagraphs = paragraphs.filter(':empty');

    emptyParagraphs.addClass('empty');

    if (paragraphs.length === 1 && emptyParagraphs.length === 1) {
      $(this).addClass('empty');
    }
  });
}